import { createSelector } from "reselect"
import { calculateHighlighter } from "../../helpers/highlighter"
import { getDate, getScaleX, getMinX, getMaxX } from "."
import { getBreakdownScaleY, getBreakdownMaxY } from "./breakdown"

export const getHighlighter = createSelector(
  [getDate, getScaleX, getBreakdownScaleY, getMinX, getMaxX, getBreakdownMaxY],
  calculateHighlighter,
)
